import { JobIssue } from '@crimsontide/core/client/interfaces'
import DotNetObject = DotNet.DotNetObject;

export const JobIssueService = (() => {
  let dotNetObj: DotNetObject;
  let cachedJobIssues: JobIssue[];

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getJobIssuesByJobCategoryIds = async (jobCategoryIds: string[]): Promise<JobIssue[]> => {
    if (dotNetObj) {
      return await dotNetObj.invokeMethodAsync<JobIssue[]>('GetByJobCategoryIdsAsync', jobCategoryIds);
    } else {
      throw 'Job Issue DotNet Object Reference has not yet been implemented';
    }
  };

  const getJobIssues = async (useCache: boolean = true): Promise<JobIssue[]> => {
    if (useCache && cachedJobIssues != null)
      return cachedJobIssues;

    if (dotNetObj) {
      cachedJobIssues = await dotNetObj.invokeMethodAsync<JobIssue[]>('GetAllAsync');
      return cachedJobIssues;
    } else {
      throw 'Job Issue DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getJobIssuesByJobCategoryIds,
    getJobIssues,
  };
})();
